import { Client } from "@/types/page";
import { Price } from "@/types/price";
import { PromotionCode } from "@/types/PromotionCode";
import { formatMoneyWithCurrency } from "@/utils/moneyFormatting";

type PromoCodeBadgeProps = {
    price: Price;
    promotionCode: PromotionCode;
    client: Client;
};

export default function PromoCodeBadge({
    price,
    promotionCode,
    client,
}: PromoCodeBadgeProps) {
    const getTodaysCostAfterCoupon = () => {
        if (promotionCode.coupon.amountOff) {
            return Math.max(0, price.amount - promotionCode.coupon.amountOff);
        }

        return (
            price.amount * (100 - (promotionCode.coupon.percentOff ?? 0)) * 0.01
        );
    };

    const getAmountOffString = () => {
        const items = [];
        if (promotionCode.coupon.amountOff) {
            items.push(
                `${formatMoneyWithCurrency(promotionCode.coupon.amountOff, client.currency ?? "usd")} credit`,
            );
        }
        if (promotionCode.coupon.percentOff) {
            items.push(`${promotionCode.coupon.percentOff}% off`);
        }
        return items.join(", ");
    };

    const todaysCostAfterCoupon = formatMoneyWithCurrency(
        getTodaysCostAfterCoupon(),
        client.currency ?? "usd",
    );

    return (
        <div className="mt-4 rounded-lg bg-brand-green/10 p-4 text-brand-black border border-brand-green">
            <div className="font-bold">
                Promo code {promotionCode.code} applied — {getAmountOffString()}
            </div>

            <div>
                Your cost today:{" "}
                <span className="font-bold line-through">
                    {price.amountForDisplay}
                </span>{" "}
                <span className="font-bold">{todaysCostAfterCoupon}</span>
            </div>
        </div>
    );
}
